import {POPUP_SHOW_CREDIT_CARD_POPUP, POPUP_SHOW_PAYMENT_GATEWAY_POPUP, POPUP_SHOW_MANUFACTURER_FILTERS_POPUP, POPUP_SHOW_CLIQ_SUBMID_INFO_POPUP} from "../../constants/actionTypes";
import {getApiConfig} from "../../utilities";
import * as actionTypes from "../../constants/actionTypes";
import * as popupActions from '../../actions/A_Popups';

export const ActionTypes = {
  TOGGLE_SECTION_OPENED: 'account/TOGGLE_SECTION_OPENED',
  TOGGLE_ALL_SECTIONS_OPENED: 'account/TOGGLE_ALL_SECTIONS_OPENED',
  SET_ACCOUNT_PAGE_INFO: 'account/SET_ACCOUNT_PAGE_INFO',
  SET_BILLING_INFORMATION: 'account/SET_BILLING_INFORMATION',
  SET_PAYMENT_GATEWAY_INFO: 'account/SET_PAYMENT_GATEWAY_INFO',
  SET_MANUFACTURER_FILTERS: 'account/SET_MANUFACTURER_FILTERS',
  SET_CLIQ_SUBMID_INFO: 'account/SET_CLIQ_SUBMID_INFO',
  SET_SUBSCRIPTIONS_INFO: 'account/SET_SUBSCRIPTIONS_INFO',
  SET_ACTIVE_WEB_HOOK_DATA_TYPE: 'account/SET_ACTIVE_WEB_HOOK_DATA_TYPE',
  FORM_SUBMIT: 'account/FORM_SUBMIT'
}

export const toggleSectionOpened = (sectionKey) => ({
  type: ActionTypes.TOGGLE_SECTION_OPENED,
  payload: { sectionKey }
});

export const toggleAllSectionsOpened = (openAll) => ({
  type: ActionTypes.TOGGLE_ALL_SECTIONS_OPENED,
  payload: { openAll }
});

export const setAccountPageInfo = (accountPageInfo) => ({
  type: ActionTypes.SET_ACCOUNT_PAGE_INFO,
  payload: { accountPageInfo }
});

export const setBillingInformation = (billingInformation) => ({
  type: ActionTypes.SET_BILLING_INFORMATION,
  payload: { billingInformation }
});

export const setPaymentGatewayInfo = (paymentGatewayInfo) => ({
  type: ActionTypes.SET_PAYMENT_GATEWAY_INFO,
  payload: { paymentGatewayInfo }
});

export const setManufacturerFilters = (manufacturerFilters) => ({
  type: ActionTypes.SET_MANUFACTURER_FILTERS,
  payload: {manufacturerFilters}
})

export const setCliqSubMidInfo = (cliqSubMidInfo) => ({
  type: ActionTypes.SET_CLIQ_SUBMID_INFO,
  payload: { cliqSubMidInfo }
});

export const setSubscriptionsInfo = (subscriptionsInfo) => dispatch => {
  dispatch({
    type: ActionTypes.SET_SUBSCRIPTIONS_INFO,
    payload: { subscriptionsInfo }
  });
  return Promise.resolve();
};

export const togglePaymentGatewayPopup = (showPaymentGatewayPopup) => ({
  type: POPUP_SHOW_PAYMENT_GATEWAY_POPUP,
  payload: { showPaymentGatewayPopup }
});

export const toggleManufacturerFiltersPopup = (showManufacturerFiltersPopup) => ({
  type: POPUP_SHOW_MANUFACTURER_FILTERS_POPUP,
  payload: { showManufacturerFiltersPopup }
});

export const toggleExportFabricatorsPopup = (showExportFabricatorsPopup) => ({
  type: POPUP_SHOW_PAYMENT_GATEWAY_POPUP,
  payload: { showExportFabricatorsPopup }
});

export const toggleCliqSubMidInfoPopup = (showCliqSubMidInfoPopup) => ({
  type: POPUP_SHOW_CLIQ_SUBMID_INFO_POPUP,
  payload: { showCliqSubMidInfoPopup }
});

export const toggleCreditCardPopup = (showCreditCardPopup) => ({
  type: POPUP_SHOW_CREDIT_CARD_POPUP,
  payload: { showCreditCardPopup }
});

export const setActiveWebHookDataType = (activeWebHookDataType) => ({
  type: ActionTypes.SET_ACTIVE_WEB_HOOK_DATA_TYPE,
  payload: { activeWebHookDataType }
});

export function toggleFormSubmitted(formSubmitted) {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.FORM_SUBMIT,
      payload: { formSubmitted }
    });
  }
}

export function addNewQuote(userId, intl) {
  return (dispatch, getState) => {
    let state = getState();
    console.log(state);
    const { auth, asCustomer } = state;
    dispatch({
      type: actionTypes.POPUP_IN_PROGRESS,
      payload: {
        show: true,
        title: intl.formatMessage({id: "loader.loading"}),
        message: intl.formatMessage({id: "loader.quoteCreating"})
      }
    });
    getApiConfig('Users/')
      .get(`CreateNewQuote/${userId}`)
      .then((response) => {
        console.log(response);
        dispatch({
          type: actionTypes.POPUP_IN_PROGRESS,
          payload: {
            show: false
          }
        });
        if(response)
          dispatch(popupActions.messageBoxEx_Show(
            true,
            'system',
            intl.formatMessage({id: "messageBox.successTitle"}),
            intl.formatMessage({id: "messageBox.quoteCreated"}),
          ));
        else
          dispatch(popupActions.messageBoxEx_Show(
            true,
            'system',
            intl.formatMessage({id: "messageBox.errorTitle"}),
            intl.formatMessage({id: "messageBox.quoteCreateFailed"}),
          ));
      });
  }
}
